<script>
import ListBlogCoursePagesComponent from '../features/lists/ListBlogCoursePagesComponent';
import FooterView from '../../shared/views/MainFooterView';
import BrandLogo from '../../shared/BrandLogo.vue';
export default {
  name: 'BlogCoursePageView',
  components: {
        'brand-logo': BrandLogo,
    'footer-view': FooterView,
  },
  extends: ListBlogCoursePagesComponent,
};
</script>

<template>
  <div class="public-page-wrapper">
    <!-- Header -->
    <header class="public-header">
      <div class="public-header__inner">
        <router-link to="/">
          <brand-logo variant="dark" />
        </router-link>
        <nav class="public-header__nav">
          <router-link to="/">Inicio</router-link>
          <router-link to="/acerca">Acerca</router-link>
          <router-link to="/cursos">Cursos</router-link>
          <router-link to="/noticias">Noticias</router-link>
          <router-link to="/contacto">Contacto</router-link>
        </nav>
        <div class="public-header__actions">
          <router-link
            to="/login"
            class="btn-outline"
          >
            Iniciar Sesión
          </router-link>
          <router-link
            to="/registrarse"
            class="btn-fill"
          >
            Registrarse
          </router-link>
        </div>
      </div>
    </header>

    <!-- Hero -->
    <section class="public-hero">
      <div class="public-hero__inner">
        <nav class="public-hero__nav">
          <router-link to="/">Inicio</router-link>
          <span>/</span>
          <a
            href="#"
            class="active"
          >Cursos</a>
        </nav>
        <h1 class="public-hero__title">Cursos Publicados</h1>
        <p class="public-hero__subtitle">Explora nuestra colección de cursos diseñados para tu desarrollo académico y profesional.</p>
      </div>
    </section>

    <!-- Body -->
    <main class="public-body">
      <div class="row">
        <!-- Search & Filter -->
        <div class="col-lg-12 mb-24">
          <div class="public-card course-search-card">
            <div class="course-search-card__inner">
              <h3>Buscar Cursos</h3>
              <el-input
                v-model="filterOptions.titleFilter"
                size="default"
                placeholder="Escribe el nombre del curso que buscas..."
                prefix-icon="el-icon-search"
                clearable
                @keyup.enter="onAllFilterChange(filterOptions.titleFilter, 'Title')"
              />
            </div>
          </div>
        </div>

        <!-- Courses Grid -->
        <div
          v-loading="fullLoader"
          class="col-lg-12"
          element-loading-text="Cargando cursos..."
        >
          <div
            v-if="collection.length > 0"
            class="course-grid"
          >
            <div
              v-for="course in collection"
              :key="course.id"
              class="course-card"
            >
              <div class="course-card__image">
                <router-link
                  :to="'/cursos/' + course.id"
                  class="course-pointer"
                >
                  <img
                    :src="getCoverImage(course.coverImageUrl)"
                    :alt="course.title"
                  >
                  <div class="course-card__overlay">
                    <span class="play-btn"><i class="uil uil-play" /></span>
                  </div>
                </router-link>
                <div class="course-card__hours">
                  <i class="uil uil-clock" /> {{ course.totalHours }} Horas
                </div>
              </div>
              <div class="course-card__content">
                <div class="course-card__meta">
                  <span><i class="uil uil-eye" /> {{ course.totalViewed }} vistas</span>
                  <span><i class="uil uil-calendar-alt" /> {{ course.lastView }}</span>
                </div>
                <h3 class="course-card__title">
                  <router-link :to="'/cursos/' + course.id">
                    {{ course.title }}
                  </router-link>
                </h3>
                <div class="course-card__tags">
                  {{ mapTags(course.tags) }}
                </div>
                <div class="course-card__footer">
                  <div
                    v-if="course.author"
                    class="course-card__author"
                  >
                    <i class="uil uil-user" /> {{ course.author }}
                  </div>
                  <button
                    class="course-card__like course-pointer"
                    :class="{ 'course-card__like--active': false }"
                    @click="onDoLike(course)"
                  >
                    <i :class="getSocialStatusClass(false)" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty state -->
          <div
            v-else-if="!fullLoader"
            class="course-empty-state"
          >
            <i class="uil uil-book-open" />
            <h3>No hay cursos disponibles</h3>
            <p>Intenta ajustar tu búsqueda o vuelve más tarde.</p>
            <el-button
              type="primary"
              @click="filterOptions.titleFilter = ''; onAllFilterChange('', 'Title')"
            >
              Ver todos los cursos
            </el-button>
          </div>
        </div>

        <!-- Pagination -->
        <div
          v-if="pagination.totalPages > 1"
          class="col-lg-12"
        >
          <div class="course-pagination">
            <el-pagination
              v-model:current-page="currentPage"
              background
              layout="prev, pager, next"
              :page-count="pagination.totalPages"
              @current-change="onPageChange"
            />
          </div>
        </div>
      </div>
    </main>

    <footer-view />
  </div>
</template>

<style scoped>
.mb-24 {
  margin-bottom: 24px;
}

.course-search-card {
  padding: 20px 24px;
}

.course-search-card__inner {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.course-search-card__inner h3 {
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.course-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}

.course-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.course-card:hover {
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);
  transform: translateY(-2px);
}

.course-card__image {
  position: relative;
  height: 180px;
  overflow: hidden;
}

.course-card__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.course-card:hover .course-card__image img {
  transform: scale(1.05);
}

.course-card__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent 40%, rgba(15, 23, 42, 0.4) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.course-card:hover .course-card__overlay {
  opacity: 1;
}

.play-btn {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-btn i {
  font-size: 20px;
  color: #0D47A1;
  margin-left: 3px;
}

.course-card__hours {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(15, 23, 42, 0.8);
  color: #fff;
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.course-card__hours i {
  font-size: 12px;
}

.course-card__content {
  padding: 16px;
}

.course-card__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.course-card__meta span {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  color: #94a3b8;
}

.course-card__meta i {
  font-size: 12px;
}

.course-card__title {
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.course-card__title a {
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;
}

.course-card__title a:hover {
  color: #0D47A1;
}

.course-card__tags {
  font-family: 'Roboto', sans-serif;
  font-size: 0.8125rem;
  color: #64748b;
  margin-bottom: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.course-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}

.course-card__author {
  font-family: 'Roboto', sans-serif;
  font-size: 0.8125rem;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 4px;
}

.course-card__author i {
  font-size: 14px;
  color: #94a3b8;
}

.course-card__like {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.course-card__like:hover {
  background: #EEF5FC;
}

.course-card__like i {
  font-size: 18px;
  color: #94a3b8;
  transition: color 0.2s ease;
}

.course-card__like:hover i {
  color: #ef4444;
}

.course-card__like--active i {
  color: #ef4444;
}

/* Empty State */
.course-empty-state {
  text-align: center;
  padding: 60px 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.course-empty-state i {
  font-size: 48px;
  color: #cbd5e1;
  margin-bottom: 16px;
  display: block;
}

.course-empty-state h3 {
  font-family: 'Roboto', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
}

.course-empty-state p {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #64748b;
  margin: 0 0 20px;
}

/* Pagination */
.course-pagination {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

/* Responsive */
@media (max-width: 768px) {
  .course-grid {
    grid-template-columns: 1fr;
  }
}
</style>

